import { apiClientWithRefreshToken } from "@/api/apiClient";
import { FreelancerPayslipFormSchema } from "@/v2/schema/payslip";
import { Payslip } from "@/v2/types";

export default async function CreateFreelancerPayslip(
  data: FreelancerPayslipFormSchema,
): Promise<Payslip> {
  const res = await apiClientWithRefreshToken({
    url: "/payslips",
    method: "POST",
    data: data,
  });

  return res.data;
}
